// import { uniqueHashCount } from '../../utils/historyHelpers';
import { formatUTCDate } from '../../utils/converter';
// import { hashExistInFiles } from '../../utils/fileHelpers';

export const Summary = ({ reportData, blockHistory }) => {
  return (
    <div className="flex flex-col bg-[#17191C] p-4 sm:p-6 md:p-[24px] rounded-lg gap-4 sm:gap-6 w-full">
      <div className="space-y-4 sm:space-y-6 md:space-y-[22.4px] text-sm sm:text-base font-normal">
        <h3 className="text-xl md:text-2xl">Summary</h3>
        {reportData && +reportData.VALID === 0 ? (
          <p>No matches were found for this file and the result is invalid.</p>
        ) : +reportData.VALID === 1 ? (
          // TODO_ fix date formatting
          <>
            <p>
              On{' '}
              <strong>
                {reportData.REQ_ID
                  ? formatUTCDate(blockHistory[0]?.BLOCK_DATE)
                  : formatUTCDate(reportData.BLOCK_DATE)}{' '}
                UTC
              </strong>
              , one or several events were recorded and stamped on the blockchain.
            </p>
            <p>
              All data in this report is sourced from the file named{' '}
              <strong className="break-words">{reportData.FILE_NAME}</strong>.
            </p>
            <p>
              The verification successfully searched for mathching hashes and got
              {+reportData.VALID === 0 ? (
                <span>
                  <strong>{` an invalid result`}</strong>
                  {` with `}
                  <strong>{`${reportData.VALIDATION_RESULT}`}</strong>.
                </span>
              ) : +reportData.VALID === 1 ? (
                <span>
                  <strong>{` a valid result`}</strong>
                  {` with a `}
                  <strong>{`${reportData.VALIDATION_RESULT}`}</strong>.
                </span>
              ) : (
                <strong>Not Verified</strong>
              )}
            </p>
          </>
        ) : null}
      </div>
    </div>
  );
};

// OLD
// export const Summary = ({ reportData }) => {
// const { files } = useContext(appContext);

//   return (
//     <div className="flex flex-col bg-[#17191C] p-[24px] rounded-[24px] gap-[24px] w-full">
//       <div className="space-y-[22.4px] text-[16px]">
//         <h3 className="text-[28px] font-semibold mb-4">Summary</h3>
//         {reportData && +reportData.VALID === 0 ? (
//           <p>No matches were found for this file and the result is invalid.</p>
//         ) : +reportData.VALID === 1 ? (
//           <>
//             <p>
//               On <strong>{reportData && formatReportDate(reportData)} UTC</strong>, one or several
//               events was recorded on the blockchain.
//             </p>
//             <p>
//               A total of <strong>{reportData && reportData.length}</strong> hash instances were
//               found onchain, with <strong>{uniqueHashCount(reportData)} unique match(es)</strong>{' '}
//               after applying the filter criteria.
//             </p>
//             <p>
//               All data in this report is sourced from the file named{' '}
//               <strong>{reportData.FILE_NAME}</strong>, which can be found in the 'Integritas' folder
//               within your MiniDapp application.
//             </p>
//             <p>
//               The verification successfully searched for mathching hashes and got
//               {+reportData.VALID === 0 ? (
//                 <span>
//                   <strong>{` an invalid result`}</strong>
//                   {` with `}
//                   <strong>{`${reportData.VALIDATION_RESULT}`}</strong>.
//                 </span>
//               ) : +reportData.VALID === 1 ? (
//                 <span>
//                   <strong>{` a valid result`}</strong>
//                   {` with a `}
//                   <strong>{`${reportData.VALIDATION_RESULT}`}</strong>.
//                 </span>
//               ) : +reportData.VALID === 2 && hashExistInFiles(files, reportData.HASH) ? (
//                 <strong>Pending</strong>
//               ) : (
//                 <strong>Not Verified</strong>
//               )}
//             </p>
//           </>
//         ) : +reportData.VALID === 2 ? (
//           hashExistInFiles(files, reportData.HASH) ? (
//             <p>This file has not been verified yet and is in the pending queue.</p>
//           ) : (
//             <p>This file has not been verified yet.</p>
//           )
//         ) : null}
//       </div>
//       <Disclaimer />
//     </div>
//   );
// };
